// extracted by mini-css-extract-plugin
export default {"helpIcon":"Label_helpIcon__llkjj","label":"Label_label__QiFIR","tooltip":"Label_tooltip__Of6Av","help":"Label_help__JtI6h"};